<template>
  <div class="container">
    <p>
      Busca y descarga las grabaciones de tus llamadas.
      <a :href="DOCS_URL" target="_blank" rel="noopener noreferrer">Click aquí</a> para conocer más.
    </p>

    <records-controls @update="handleSetFilters" @show-table="handleShowTable" :rangeDates="rangeDates" />

    <records-table v-if="showTable" :loading="loading" @update="handleChangePage" />
  </div>
</template>

<script setup>
import { computed, onMounted, reactive, ref, watch } from "vue";
import { useStore } from "vuex";

import RecordsControls from "@/app/supervision/components/tables/RecordsControls.vue";
import RecordsTable from "@/app/supervision/components/tables/RecordsTable.vue";
import { planConfigServices } from "@/app/common/services/PlanConfigServices";

const store = useStore();

const filtersState = reactive({
  filters: {},
  pagination: {},
});

const showTable = ref(false);
const loading = ref(false);

/**** validations plan confing ****/
const user = computed(() => store.getters["getDataUser"]);
const rangeDates = computed(() => store.getters["getDataPlanConfiguration"]?.recordings_search_range);

const handleShowTable = (show) => {
  showTable.value = show;
};
/**** validations plan confing ****/

const handleSetFilters = (filters) => {
  filtersState.filters = filters;
  filtersState.pagination = {
    ...filtersState.pagination,
    current: 1,
  };
  fetchData();
};

const handleChangePage = (pagination) => {
  filtersState.pagination = pagination;
  fetchData();
};

const fetchData = async () => {
  loading.value = true;
  try {
    await store.dispatch("fetchRecordList", filtersState);
  } finally {
    loading.value = false;
  }
};
const DOCS_URL = `${import.meta.env.VITE_WEB_DOC}/supervision/grabaciones-1/`;
</script>

<style lang="sass" scoped>
.container
  padding: 12px 20px
</style>
